import { Link } from "react-router-dom";

const SelectedWorkCard = (props) => {
    const selectedWorkAssetClasses = props.assetStyles || "md:min-h-[70vh] md:max-h-[70vh] min-w-full object-cover rounded-[1vh] transform object-cover duration-200 hover:scale-[103%] overflow-hidden "
    const assetDivClasses = "overflow-hidden rounded-[1vh]"
    const textColorClass = "text-" + props.textColor + "-500"
    const fullDivClasses = props.fullDivClasses || "hover:saturate-100 md:mt-8 md:mb-8 rounded-md"
    const tags = props.tags || []
    return (
        <Link to={props.linkTo} className={textColorClass}>
            <div className={fullDivClasses} data-aos="fade-up" data-aos-duration="800" >
                <div className={assetDivClasses}>
                    <h3 className={`text-[1.5rem] font-semibold tracking-tight ${textColorClass}`}>[{props.projectName}]</h3>
                    <p className="text-gray-400 flex gap-2 mb-4">
                        {tags.map((tag) => {
                            return (<p>[{tag}]</p>)
                        })}
                    </p>
                    {props.projectDescription &&
                        <p className="text-gray-700 text-[1.1rem] mt-3 mb-8 md:max-w-[50%]">{props.projectDescription}</p>
                    }
                    <div className={assetDivClasses}>
                        <img
                            className={selectedWorkAssetClasses}
                            src={props.imgSrc}
                            alt={props.altText}>
                        </img>
                    </div>
                </div>
            </div>
            {/* Sometimes the colors are not loaded by tailwind as it is variable. so this works sort of as a registration of colors to be used. */}
            <div className="hidden">
                <p className="text-red-500 hover:text-blue-500">a</p>
                <p className="text-blue-500 hover:text-blue-500">a</p>
                <p className="text-pink-500 hover:text-pink-500">a</p>
                <p className=" text-orange-500 hover:text-orange-500">a</p>
                <p className=" text-green-500 hover:text-green-500">a</p>
                <p className="text-purple-500 hover:text-purple-500">a</p>
            </div>
        </Link>
    )
}

export default SelectedWorkCard;